export function disableFileUpload(fileLength: number) {
	const fileUploadElement = document.getElementById("multiple-file-upload")?.parentElement?.parentElement;

	if (fileLength === 3) {
		fileUploadElement?.classList?.add("pointer-events-none");
	} else {
		fileUploadElement?.classList?.remove("pointer-events-none");
	}
}
